import React from 'react';
import { config } from '@triare/auth-redux';
import { Link } from 'react-router-dom';
import Simple from '../../components/Layout/Simple';

const { displayName } = config;

export default function NotFound({ children }: React.PropsWithChildren): React.ReactNode {
  document.title = `${displayName}: Not found`;

  return (
    <Simple>
      <div style={{ textAlign: 'center' }}>
        <div>{children || 'Not found'}</div>
        <Link to="/" replace>Go to home page</Link>
      </div>
    </Simple>
  );
}
